import { useSelector } from "react-redux";
import { compose } from "redux";
import withHubspotStatusCall from "app/pages/sales-intelligence/sub-modules/management/hocs/manage-status/withHubspotStatusCall";
import withSalesforceStatusCall from "app/pages/sales-intelligence/sub-modules/management/hocs/manage-status/withSalesforceStatusCall";
import SaveToListCompetitiveButtonContainer from "../SaveToList/SaveToListCompetitiveButtonContainer";
import ExportCompetitiveButtonContainer from "../ExportButton/ExportCompetitiveButtonContainer";
import { selectIsFetchingResults, selectCompetitiveResultsCount } from "../../store/selectors";
import AssignToUserCompetitiveButtonContainer from "../AssignToOtherUsersPanel/AssignToUserCompetitiveButtonContainer";
import { StyledInnerPanelContainer, StyledTableActionsPanel } from "./styles";
import { translate } from "app/filters/i18nFilter";
import AssignToUserCompetitivePanelContainer from "app/pages/sales-intelligence/sub-modules/account-overview/competitive-landscape/containers/AssignToOtherUsersPanel/AssignToUserCompetitivePanelContainer";
import type { Dispatch, SetStateAction } from "react";
import type { ActivatedChildComponentType } from "app/pages/sales-intelligence/sub-modules/table-actions-panel/components/BaseActivatedPanel/types";
import trackingService from "app/pages/sales-intelligence/services/tracking/createMultiSelectorPanelService";

const TableActionsCompetitiveContainer = () => {
    const numberOfResults = useSelector(selectCompetitiveResultsCount);
    const isFetchingResults = useSelector(selectIsFetchingResults);
    const areActionsDisabled = isFetchingResults || (numberOfResults ?? 0) === 0;

    const handleAssignToUser = (activate: Dispatch<SetStateAction<ActivatedChildComponentType>>) => {
        trackingService.trackMultiSelectorAssignToOtherUserClick();
        return activate(() => AssignToUserCompetitivePanelContainer);
    };

    return (
        <StyledTableActionsPanel>
            {({ activate }) => {
                return (
                    <StyledInnerPanelContainer>
                        <SaveToListCompetitiveButtonContainer
                            isDisabled={areActionsDisabled}
                            onActivate={activate}
                        />
                        <AssignToUserCompetitiveButtonContainer
                            isDisabled={areActionsDisabled}
                            onActivate={activate}
                            onClick={() => handleAssignToUser(activate)}
                            tooltipContent={translate("si.multi_selector.tooltip.assign")}
                        />
                        <ExportCompetitiveButtonContainer
                            isDisabled={areActionsDisabled}
                            onActivate={activate}
                        />
                    </StyledInnerPanelContainer>
                );
            }}
        </StyledTableActionsPanel>
    );
}

export default compose(withSalesforceStatusCall, withHubspotStatusCall)(TableActionsCompetitiveContainer);
